import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebaseConfig";

// Debounce function to limit callback frequency
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const listenCollectionData = (
  collectionName,
  callback,
  queryList = null
) => {
  const dataBaseQuery =
    queryList && queryList.length > 0
      ? queryList.map(({ property, operator, value }) =>
          where(property, operator, value)
        )
      : null;

  const listenCollectionQuery = dataBaseQuery
    ? query(collection(db, collectionName), ...dataBaseQuery)
    : query(collection(db, collectionName));

  // Debounce callback to prevent excessive updates
  const debouncedCallback = debounce((data) => callback(data), 100);

  return onSnapshot(listenCollectionQuery, (querySnapshot) => {
    const data = [];
    querySnapshot.forEach((doc) => data.push({ ...doc.data(), id: doc.id }));
    debouncedCallback(data);
  });
};
